/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_Src_2_DetailInputs */

const en_wb_marketing_src_2_detail = /** @type {(inputs: Wb_Marketing_Src_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`48 → 41 form submissions`)
};

const lv_wb_marketing_src_2_detail = /** @type {(inputs: Wb_Marketing_Src_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`48 → 41 aizpildīta forma`)
};

/**
* | output |
* | --- |
* | "48 → 41 form submissions" |
*
* @param {Wb_Marketing_Src_2_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_src_2_detail = /** @type {((inputs?: Wb_Marketing_Src_2_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_Src_2_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_src_2_detail(inputs)
	return en_wb_marketing_src_2_detail(inputs)
});